import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/client/lib/page";
import { PrivacidadePage } from "@/client/modules/site/privacidade-page";

export const Route = createFileRoute("/privacidade")({
  head: () => pageHead("Política de privacidade"),
  component: PrivacidadePage,
});
